export * from './IconChevronLeft';
export { default as IconChevronLeft } from './IconChevronLeft';
